import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface TaxAccessSyncLogListGridActionCellRendererParams extends ICellRendererParams {
    viewDetails: (params: TaxAccessSyncLogListGridActionCellRendererParams) => void;
}

@Component({
    selector: 'tax-access-sync-log-grid-action-cell',
    template:
        `@if (taxAccessSyncSummaryLog) {
  <button type="button"
    class="ace-btn btn-primary has-icon grid-action-button"
    (click)="params.viewDetails(params)"
    helpTooltip
    helpContentId="app.view"
    position="bottom">
    <i class="fa fa-pencil"></i>
  </button>
}`,
    standalone: false
})
export class TaxAccessSyncLogListGridActionCellRendererComponent implements ICellRendererAngularComp {
    params: TaxAccessSyncLogListGridActionCellRendererParams;
    taxAccessSyncSummaryLog: Core.TaxAccessSyncSummaryLogModel;

    agInit(params: TaxAccessSyncLogListGridActionCellRendererParams): void {
        this.params = params;
        this.taxAccessSyncSummaryLog = params.data as Core.TaxAccessSyncSummaryLogModel;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
